import { render, staticRenderFns } from "./ui-video-control.vue?vue&type=template&id=5fb2f10a&scoped=true&"
import script from "./ui-video-control.vue?vue&type=script&lang=ts&"
export * from "./ui-video-control.vue?vue&type=script&lang=ts&"
import style0 from "./ui-video-control.vue?vue&type=style&index=0&id=5fb2f10a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb2f10a",
  null
  
)

export default component.exports